<template>
  <div>
    <ValidationObserver v-slot="{invalid}">
      <b-card
        :title="item.title"
        title-tag="h5"
        class="rounded border mb-4"
      >
        <b-card-body>
          <b-form @submit.prevent="onSaveClick">
            <b-form-group
              v-for="el in item.items"
              :key="el.id"
              inline
              :label="getElement(el) !== elementType.CHECKBOX ? el.label : ''"
            >
              <system-settings-fields
                :get-input-type="getInputType"
                :element-type="elementType"
                :get-element="getElement"
                :element="el"
              />
              <div
                v-if="getElement(el) === elementType.FORM"
                class="p-4 bg-light rounded border"
              >
                <b-form-group
                  v-for="sItem in el.subItems"
                  :key="sItem.id"
                  :label="getElement(sItem) !== elementType.CHECKBOX ? sItem.label : ''"
                >
                  <system-settings-fields
                    :get-input-type="getInputType"
                    :element-type="elementType"
                    :get-element="getElement"
                    :element="sItem"
                  />
                </b-form-group>
                <b-button
                  v-if="el.itemId === 'emailConfig'"
                  variant="warning"
                  @click="handleOpenModal"
                >
                  Send Test Email
                </b-button>
              </div>
            </b-form-group>

            <b-button
              variant="primary"
              :disabled="invalid"
              class="submit_button"
              type="submit"
            >
              <template v-if="isLoading">
                <b-spinner small />
                <span class="ml-1">Loading</span>
              </template>

              <template v-else>
                Save
              </template>
            </b-button>
          </b-form>
        </b-card-body>
      </b-card>
    </ValidationObserver>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import SystemSettingsFields from '@/modules/Security/components/SystemSettingsFields.vue';
import ContentSpinner from '@/core/components/ContentSpinner.vue';

const {mapState, mapActions} = createNamespacedHelpers('systemInfo');

const elementType = {
  CHECKBOX: 'checkbox',
  INPUT: 'input',
  SELECT: 'select',
  FORM: 'form',
  PASSWORD: 'password',
};

export default {
  name: 'SystemSettingsCard',
  components: {
    SystemSettingsFields,
    ContentSpinner,
  },
  props: ['item'],
  data() {
    return {
      isLoading: false,
      elementType,
    };
  },
  computed: {
    ...mapState({
      data: state => state.systemSettings.data,
      requestData: state => state.systemSettings.requestData,
    }),
  },
  methods: {
    ...mapActions([
      'setSystemSettingsData',
      'setTestEmailModalState',
      'collectSystemSettingsRequestData',
    ]),
    handleOpenModal() {
      this.setTestEmailModalState(true);
    },
    getInputType(el) {
      if (typeof el.type === 'object') return el.type.type;
    },
    getElement(el) {
      if (typeof el.type === 'object') {
        return el.type.element;
      } else {
        return el.type;
      }
    },
    async onSaveClick() {
      this.isLoading = true;
      const currentItem = this.data.find(el => el.cardId === this.item.cardId);

      this.collectSystemSettingsRequestData({
        item: this.item.cardId,
        fields: currentItem.items,
        isModal: false,
      });

      const isSuccess = await this.setSystemSettingsData(this.requestData);

      this.$toasted[isSuccess ? 'success' : 'error'](
        isSuccess
          ? `"${currentItem.title}" was successfully updated`
          : 'An error occurred during the update process, please try again.',
        {duration: TOASTER_DURATION},
      );
      this.isLoading = false;
    },
  },
};
</script>